const ResultsParams = `
adultsCount
arrival
ascending
childrenCount
currency
departure
filter
locale
maxBathrooms
maxBedrooms
maxPrice
minBathrooms
minBedrooms
minPrice
mockApi
neLat
neLong
orderBy
page
petIncluded
pinnedPropertyListing
q
regionId
searchbucket
searchTermUuid
swLat
swLong
zoom
`
    .trim()
    .split(/\s+/);

module.exports = {ResultsParams};
